interface LoadingScreenProps {
  message?: string;
}

export default function LoadingScreen({ message = 'Loading…' }: LoadingScreenProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 font-sans">
      <div className="flex flex-col items-center gap-3 px-6 text-center">
        <div className="mb-1 flex h-12 w-12 items-center justify-center overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200">
          <img
            src="/assets/CellSourceLogo-removebg.png"
            alt=""
            className="h-10 w-10 object-contain"
            width={40}
            height={40}
          />
        </div>
        <div
          className="h-7 w-7 animate-spin rounded-full border-2 border-slate-900 border-t-transparent"
          aria-hidden="true"
        />
        <p className="text-sm font-medium text-slate-700">{message}</p>
        <p className="max-w-[16rem] text-xs text-slate-500">
          Signing you in and checking your subscription…
        </p>
      </div>
    </div>
  );
}
